const loyaltyDashboardRoutes = [
    {
        path: '/loyalty-dashboard',
        name: 'loyaltyDashboard',
        component: () => import('@/modules/loyalty_dashboard/Dashboard.vue'),
        meta: {
            resource: 'loyalty_dashboard',
            action: 'view',
            layout: 'default',
            auth: true,
            title: 'Loyalty Dashboard',
            breadcrumbs: [{ title: 'Loyalty Dashboard', routeName: 'loyaltyDashboard' }]
        }
    }
]

export default loyaltyDashboardRoutes
